(() => {
  const sectionPlan = [
    { sourceIndex: 1, id: "custom-pickups", group: "custom", label: "Custom Shop", position: "bridge" },
    { sourceIndex: 3, id: "custom-pickups-neck", group: "custom", label: "Custom Shop", position: "neck" },
    { sourceIndex: 2, id: "london-series", group: "london", label: "London Series", position: "bridge" },
    { sourceIndex: 6, id: "london-series-neck", group: "london", label: "London Series", position: "neck" },
    { sourceIndex: 4, id: "gtr-pickups", group: "gtr", label: "GTR", position: "bridge" },
    { sourceIndex: 5, id: "gtr-pickups-neck", group: "gtr", label: "GTR", position: "neck" },
  ];

  function buildTools(total) {
    const tools = document.createElement("aside");
    tools.className = "pickup-catalogue-tools";
    tools.setAttribute("aria-label", "Pickup catalogue tools");
    tools.innerHTML = `
      <div class="pickup-catalogue-tools__inner">
        <span class="pickup-catalogue-tools__label">Explore the range</span>
        <label class="pickup-catalogue-search">
          <span class="visually-hidden">Search pickups</span>
          <input type="search" placeholder="Search by name, output, magnet or style" autocomplete="off">
          <svg aria-hidden="true" viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="7"></circle>
            <path d="m16.5 16.5 4 4"></path>
          </svg>
        </label>
        <span class="pickup-catalogue-results" aria-live="polite">${total} pickups</span>
        <div class="pickup-filter-panel" id="pickup-filter-panel">
          <label>
            <span>Range</span>
            <select data-filter="range">
              <option value="">All ranges</option>
              <option value="custom">Custom Shop</option>
              <option value="london">London Series</option>
              <option value="gtr">GTR</option>
            </select>
          </label>
          <label>
            <span>Output level</span>
            <select data-filter="output">
              <option value="">All output levels</option>
              <option value="low">Low · under 10k</option>
              <option value="medium">Medium · 10–14.9k</option>
              <option value="high">High · 15k+</option>
            </select>
          </label>
          <label>
            <span>Position</span>
            <select data-filter="position">
              <option value="">Bridge &amp; neck</option>
              <option value="bridge">Bridge</option>
              <option value="neck">Neck</option>
            </select>
          </label>
          <label>
            <span>Magnet</span>
            <select data-filter="magnet">
              <option value="">All magnets</option>
              <option value="alnico-2">Alnico 2</option>
              <option value="alnico-5">Alnico 5</option>
              <option value="alnico-8">Alnico 8</option>
              <option value="ceramic">Ceramic</option>
            </select>
          </label>
          <label>
            <span>Type</span>
            <select data-filter="type">
              <option value="">All types</option>
            </select>
          </label>
          <button class="pickup-filter-clear" type="button">Clear filters</button>
        </div>
      </div>
    `;
    return tools;
  }

  function addFilterData(card, position, group) {
    const specs = card.querySelector(".enhanced-richtext p")?.innerText || "";
    const output = Number.parseFloat(specs.match(/Output level:\s*([\d.]+)/i)?.[1]);
    const type = specs.match(/Type:\s*([^\n]+)/i)?.[1].replace(/\s+/g, " ").trim() || "";
    const normalizedSpecs = specs.toLowerCase();
    const magnets = [];

    if (/alnico\s*(?:ii|2)\b/i.test(normalizedSpecs)) magnets.push("alnico-2");
    if (/alnico\s*(?:v|5)\b/i.test(normalizedSpecs)) magnets.push("alnico-5");
    if (/alnico\s*(?:viii|8)\b/i.test(normalizedSpecs)) magnets.push("alnico-8");
    if (normalizedSpecs.includes("ceramic")) magnets.push("ceramic");

    card.dataset.pickupPosition = position;
    card.dataset.pickupRange = group;
    card.dataset.pickupOutput = Number.isNaN(output) ? "" : output < 10 ? "low" : output < 15 ? "medium" : "high";
    card.dataset.pickupMagnet = magnets.join(" ");
    card.dataset.pickupType = type;
  }

  function buildDetailDialog() {
    const dialog = document.createElement("dialog");
    dialog.className = "pickup-detail-dialog";
    dialog.setAttribute("aria-labelledby", "pickup-detail-title");
    dialog.innerHTML = `
      <div class="pickup-detail-dialog__panel">
        <button class="pickup-detail-dialog__close" type="button" aria-label="Close pickup details">&times;</button>
        <div class="pickup-detail-dialog__image"></div>
        <div class="pickup-detail-dialog__content">
          <span class="pickup-detail-dialog__eyebrow">Pickup specifications</span>
          <h2 id="pickup-detail-title"></h2>
          <div class="pickup-detail-dialog__description"></div>
          <div class="pickup-detail-dialog__action"></div>
        </div>
      </div>
    `;

    dialog.querySelector(".pickup-detail-dialog__close").addEventListener("click", () => dialog.close());
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) dialog.close();
    });
    document.body.append(dialog);
    return dialog;
  }

  function addCardControls(card, dialog) {
    const title = card.querySelector(".block-title")?.textContent.trim() || "Ormsby pickup";
    const image = card.querySelector("img");
    const description = card.querySelector(".enhanced-richtext");

    if (image && (!image.alt || image.alt.toLowerCase() === "image description")) {
      image.alt = title;
    }

    if (!description || description.textContent.trim().length < 320) return;

    const button = document.createElement("button");
    button.className = "pickup-card__toggle";
    button.type = "button";
    button.textContent = "View full details";
    button.setAttribute("aria-haspopup", "dialog");
    button.addEventListener("click", () => {
      const dialogImage = dialog.querySelector(".pickup-detail-dialog__image");
      const dialogAction = dialog.querySelector(".pickup-detail-dialog__action");
      dialog.querySelector("#pickup-detail-title").textContent = title;
      dialog.querySelector(".pickup-detail-dialog__description").innerHTML = description.innerHTML;
      dialogImage.replaceChildren();
      dialogAction.replaceChildren();

      if (image) dialogImage.append(image.cloneNode());
      const shopLink = card.querySelector(".button-container a");
      if (shopLink) dialogAction.append(shopLink.cloneNode(true));

      dialog.showModal();
    });

    const buttonContainer = card.querySelector(".button-container");
    buttonContainer?.parentElement?.insertBefore(button, buttonContainer);
  }

  function initPickups() {
    const main = document.querySelector(".template-page-pickups #MainContent");
    if (!main || main.querySelector(".pickup-catalogue-tools")) return;

    const containers = [...main.querySelectorAll(".ormsby-section-container")];
    if (containers.length < 7) return;

    containers[0].classList.add("pickups-intro");
    const dialog = buildDetailDialog();

    const catalogueSections = sectionPlan
      .map((item) => {
        const container = containers[item.sourceIndex];
        const section = container?.closest(".shopify-section");
        if (!container || !section) return null;

        section.id = item.id;
        section.dataset.pickupGroup = item.group;
        section.dataset.pickupLabel = item.label;
        container.classList.add("pickup-catalogue-section");

        container.querySelectorAll(".flex-item").forEach((card) => {
          addFilterData(card, item.position, item.group);
          addCardControls(card, dialog);
        });
        return section;
      })
      .filter(Boolean);

    if (!catalogueSections.length) return;

    const cards = catalogueSections.flatMap((section) => [...section.querySelectorAll(".flex-item")]);
    const tools = buildTools(cards.length);
    catalogueSections[0].before(tools);

    const finalCatalogueSection = containers[6].closest(".shopify-section");
    const anchor = finalCatalogueSection.nextElementSibling;
    catalogueSections.forEach((section) => main.insertBefore(section, anchor));

    const search = tools.querySelector('input[type="search"]');
    const results = tools.querySelector(".pickup-catalogue-results");
    const filterSelects = [...tools.querySelectorAll("[data-filter]")];
    const typeSelect = tools.querySelector('[data-filter="type"]');
    const types = [...new Set(cards.map((card) => card.dataset.pickupType).filter(Boolean))].sort();

    types.forEach((type) => typeSelect.add(new Option(type, type)));

    function applyFilters() {
      const query = search.value.trim().toLowerCase();
      const filters = Object.fromEntries(filterSelects.map((select) => [select.dataset.filter, select.value]));
      const activeFilterCount = Object.values(filters).filter(Boolean).length;
      let visibleCount = 0;

      catalogueSections.forEach((section) => {
        let sectionCount = 0;
        section.querySelectorAll(".flex-item").forEach((card) => {
          const matchesSearch = !query || card.textContent.toLowerCase().includes(query);
          const matchesRange = !filters.range || card.dataset.pickupRange === filters.range;
          const matchesOutput = !filters.output || card.dataset.pickupOutput === filters.output;
          const matchesPosition = !filters.position || card.dataset.pickupPosition === filters.position;
          const matchesMagnet = !filters.magnet || card.dataset.pickupMagnet.includes(filters.magnet);
          const matchesType = !filters.type || card.dataset.pickupType === filters.type;
          const matches =
            matchesSearch && matchesRange && matchesOutput && matchesPosition && matchesMagnet && matchesType;
          card.hidden = !matches;
          if (matches) {
            sectionCount += 1;
            visibleCount += 1;
          }
        });
        section.hidden = sectionCount === 0;
      });

      results.textContent = query || activeFilterCount
        ? `${visibleCount} ${visibleCount === 1 ? "pickup" : "pickups"} found`
        : `${cards.length} pickups`;
    }

    search.addEventListener("input", applyFilters);
    filterSelects.forEach((select) => select.addEventListener("change", applyFilters));
    tools.querySelector(".pickup-filter-clear").addEventListener("click", () => {
      filterSelects.forEach((select) => {
        select.value = "";
      });
      applyFilters();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPickups);
  } else {
    initPickups();
  }

  document.addEventListener("shopify:section:load", initPickups);
})();
